<template lang="pug">
#app
  PushList
  PopupDispatcher
  BasePreloader
  Jivosite
  router-view
</template>

<script>
import BasePreloader from '@/components/BasePreloader.vue';
import PushList from '@/components/app/push/PushList.vue';
import PopupDispatcher from '@/components/popup/PopupDispatcher.vue';
import Jivosite from '@/components/base/Jivosite.vue';

export default {
  components: {
    Jivosite,
    PopupDispatcher,
    PushList,
    BasePreloader,
  },
  methods: {
    preventPageClosing(e) {
      if (this.$store.state.closePrevent.enabled) {
        e.preventDefault();
        e.returnValue = '';
      }
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.preventPageClosing);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventPageClosing);
  },
};
</script>

<style>
html {
  overflow-y: scroll;
}
</style>
